import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './signing-session.reducer';

export const SigningSessionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const signingSessionEntity = useAppSelector(state => state.signingSession.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="signingSessionDetailsHeading">
          <Translate contentKey="crawlerBackendApp.signingSession.detail.title">SigningSession</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{signingSessionEntity.id}</dd>
          <dt>
            <span id="uuid">
              <Translate contentKey="crawlerBackendApp.signingSession.uuid">Uuid</Translate>
            </span>
          </dt>
          <dd>{signingSessionEntity.uuid}</dd>
          <dt>
            <span id="documentType">
              <Translate contentKey="crawlerBackendApp.signingSession.documentType">Document Type</Translate>
            </span>
          </dt>
          <dd>{signingSessionEntity.documentType}</dd>
          <dt>
            <span id="documentReferenceId">
              <Translate contentKey="crawlerBackendApp.signingSession.documentReferenceId">
                Document Reference Id
              </Translate>
            </span>
          </dt>
          <dd>{signingSessionEntity.documentReferenceId}</dd>
          <dt>
            <span id="documentPath">
              <Translate contentKey="crawlerBackendApp.signingSession.documentPath">Document Path</Translate>
            </span>
          </dt>
          <dd>{signingSessionEntity.documentPath}</dd>
          <dt>
            <span id="signedDocumentPath">
              <Translate contentKey="crawlerBackendApp.signingSession.signedDocumentPath">
                Signed Document Path
              </Translate>
            </span>
          </dt>
          <dd>{signingSessionEntity.signedDocumentPath}</dd>
          <dt>
            <span id="documentHash">
              <Translate contentKey="crawlerBackendApp.signingSession.documentHash">Document Hash</Translate>
            </span>
          </dt>
          <dd>{signingSessionEntity.documentHash}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="crawlerBackendApp.signingSession.status">Status</Translate>
            </span>
          </dt>
          <dd>{signingSessionEntity.status}</dd>
          <dt>
            <span id="createdAt">
              <Translate contentKey="crawlerBackendApp.signingSession.createdAt">Created At</Translate>
            </span>
          </dt>
          <dd>
            {signingSessionEntity.createdAt ? (
              <TextFormat value={signingSessionEntity.createdAt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="updatedAt">
              <Translate contentKey="crawlerBackendApp.signingSession.updatedAt">Updated At</Translate>
            </span>
          </dt>
          <dd>
            {signingSessionEntity.updatedAt ? (
              <TextFormat value={signingSessionEntity.updatedAt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.signingSession.customer">Customer</Translate>
          </dt>
          <dd>{signingSessionEntity.customer ? signingSessionEntity.customer.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.signingSession.contact">Contact</Translate>
          </dt>
          <dd>{signingSessionEntity.contact ? signingSessionEntity.contact.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/signing-session" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/signing-session/${signingSessionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SigningSessionDetail;
